var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandCollapseAppliedFilterMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.28,
    height: 28.28,
    viewBox: "0 0 28.28 28.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30232",
    "data-name": "Group 30232",
    transform: "translate(-1080.031 -1276.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29957",
    "data-name": "Group 29957",
    transform: "translate(1078.031 1276.465)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "highlight_off_black_18dp",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17204",
    "data-name": "Path 17204",
    d: "M0,0H28.28V28.28H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17205",
    "data-name": "Path 17205",
    d: "M14.14,2A12.14,12.14,0,1,0,26.28,14.14,12.129,12.129,0,0,0,14.14,2Zm0,21.852a9.712,9.712,0,1,1,9.712-9.712A9.725,9.725,0,0,1,14.14,23.852Z",
    fill: "#63666a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_217",
    "data-name": "Polygon 217",
    d: "M6.5,0,13,8H0Z",
    transform: "translate(1100.671 1295.75) rotate(180)",
    fill: "#63666a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCollapseAppliedFilterMobile);
export default __webpack_public_path__ + "static/media/expand-collapse-applied-filter-mobile.a32a26f40d864ea81b31ce624f7cf194.svg";
export { ForwardRef as ReactComponent };